export const TOKEN = sessionStorage.getItem('token');
export const USERNAME = sessionStorage.getItem('username');
export const FIRST_NAME = sessionStorage.getItem('firstName');
export const _ID = sessionStorage.getItem('_id');

export const SIGN_UP = "/api/user/signup"
export const PATH_LOGIN = "/api/users/login"